import styled from 'styled-components';
import { ModalFindDealerStyled } from '../ModalFindDealerStyled';
export const ModalFindDealerStyledAC = styled(ModalFindDealerStyled)``;
